import "./OTAListingOptimizationServices.module.css";
import Header from "@/reusable_sections/Header";
import OtaOptimizationHero from "./sections/OtaOptimizationHero";
import RevenueJourneyContactForm from "./sections/RevenueJourneyContactForm";
import OtaServiceBreakdown from "./sections/OtaServiceBreakdown";
import RevenueOptimizationFaq from "./sections/RevenueOptimizationFaq";
import AuditOptimization from "./sections/AuditOptimization";
import Footer from "@/reusable_sections/Footer";
export default function OTAListingOptimizationServicesPage() {
  return <div>
      <Header />
      <OtaOptimizationHero />
      <RevenueJourneyContactForm />
      <OtaServiceBreakdown />
      <RevenueOptimizationFaq />
      <AuditOptimization />
      <Footer />
    </div>;
}